<template>

</template>

<script>
  export default {
    data() {
      return {
        token: null,
        isValid: true,
      };
    },
    created() {
      this.token = this.$route.params.token;
      // console.log(`this.$route.params.token: ${this.$route.params.token}`);
      if (this.token) {
        this.$router.push({ name: 'pwdResetConfirm', params: { token: this.token } });
      }
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/signing/PwdTokenValid.vue